var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.75L3.75 5.25V13.5C3.75 20.4375 8.55 26.925 15 28.5C21.45 26.925 26.25 20.4375 26.25 13.5V5.25L15 0.75ZM23.25 13.5C23.25 18.8025 19.74 23.9175 15 25.395C10.26 23.9175 6.75 18.8025 6.75 13.5V7.305L15 4.005L23.25 7.305V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 16.53L10.56 13.89L8.43994 16.0125L13.2 20.7825L21.5599 12.42L19.4399 10.2975L13.2 16.53Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy_policy.f5b6e171965c7968e8d9a30d458e8507.svg";
export { ForwardRef as ReactComponent };